import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib';
import '@/sass/overrides.sass';

Vue.use(Vuetify, {
    components: {
        VSnackbar,
        VBtn,
        VIcon,
    }
});

const theme = {
    primary: '#00a9a9',
    secondary: '#9C27b0',
    accent: '#9C27b0',
    info: '#00CAE3',
}

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            dark: theme,
            light: theme
        }
    }
});